function getElementY(element) {
    return window.scrollY + element.getBoundingClientRect().top;
}
export function scrollToElement(element, duration, padding = 0) {
    const startingY = window.scrollY;
    const elementY = getElementY(element) - padding;
    // If element is close to page's bottom then window will scroll only to some position above the element.
    const targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
    const diff = targetY - startingY;
    // Easing function: easeOutCubic
    // From: https://gist.github.com/gre/1650294
    const easing = function (t) {
        return (--t) * t * t + 1;
    };
    let start = null;
    if (!diff)
        return;
    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
        if (!start)
            start = timestamp;
        // Elapsed milliseconds since start of scrolling.
        const time = timestamp - start;
        // Get percent of completion in range [0, 1].
        let percent = Math.min(time / duration, 1);
        // Apply the easing.
        // It can cause bad-looking slow frames in browser performance tool, so be careful.
        percent = easing(percent);
        window.scrollTo(0, startingY + diff * percent);
        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
            window.requestAnimationFrame(step);
        }
    });
}
